import {useEffect, useState} from 'react'
import Table from 'react-bootstrap/Table'
import {Link, useSearchParams} from 'react-router-dom'
import Datetime from './ui/Datetime'
import ErrorMessage from './ui/ErrorMessage'
import Headline from './ui/Headline'
import Pagination from './ui/Pagination'
import {parseErrors} from '../api'
import {readJsonSchemas} from '../api/json-schemas'

const JsonSchemaList = ({user}) => {
  const [errors, setErrors] = useState([])
  const [page, setPage] = useState()
  const [pagination, setPagination] = useState({})
  const [searchParams] = useSearchParams()

  const paginate = async page => {
    const r = await readJsonSchemas({dataType: null, page: page || 1})
    try {
      setPagination(r)
    }
    catch(err) {
      setErrors(parseErrors(err))
    }
  }

  useEffect(() => {
    let newPage = Number(searchParams.get('page'))
    if(isNaN(newPage) || newPage === 0) {
      newPage = 1
    }
    setPage(newPage)

    paginate(newPage)
  }, [searchParams])

  return (
    <div>
      <Headline>JSON Schema 一覧</Headline>
      <ErrorMessage errors={errors}/>
      {pagination.data &&
        <Table striped bordered>
          <thead>
            <tr>
              <th>#</th>
              <th>名前</th>
              {/*<th>データタイプ</th>*/}
              <th>作成日時</th>
              <th>更新日時</th>
              <th>アクション</th>
            </tr>
          </thead>
          <tbody>
            {pagination.data.map(item => 
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.name}</td>
                {/*<td>{DATA_TYPES_JA_MAP[item.data_type.toString()]}</td>*/}
                <td><Datetime date={item.created_at}/></td>
                <td><Datetime date={item.updated_at}/></td>
                <td>
                  <Link to={`/json-schemas/${item.id}`}>編集</Link>
                  <Link className="ms-3" to={`/json-schemas/${item.id}/uis`}>UI 編集</Link>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      }
      <Pagination page={page} pages={pagination.pages}/>
    </div>
  )
}

export default JsonSchemaList
